/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterAccountRouteImport } from './routes/register-account'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ActivateAccountRouteImport } from './routes/activate-account'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as AuthenticatedStatisticsRouteImport } from './routes/_authenticated/statistics'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedPackagesRouteImport } from './routes/_authenticated/packages'
import { Route as AuthenticatedOverviewRouteImport } from './routes/_authenticated/overview'
import { Route as AuthenticatedOrganizationSettingsRouteImport } from './routes/_authenticated/organization-settings'
import { Route as AuthenticatedFriskvardRouteImport } from './routes/_authenticated/friskvard'
import { Route as AuthenticatedDepartmentsRouteImport } from './routes/_authenticated/departments'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedCompetitionsIndexRouteImport } from './routes/_authenticated/competitions/index'
import { Route as AuthenticatedUsersUserIdRouteImport } from './routes/_authenticated/users/$userId'
import { Route as AuthenticatedCompetitionsNewRouteImport } from './routes/_authenticated/competitions/new'
import { Route as AuthenticatedCompetitionsCompetitionIdRouteImport } from './routes/_authenticated/competitions/$competitionId'
import { Route as AuthenticateddeveloperDesignSystemRouteImport } from './routes/_authenticated/(developer)/design-system'
import { Route as AuthenticateddeveloperDebugRouteImport } from './routes/_authenticated/(developer)/debug'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterAccountRoute = RegisterAccountRouteImport.update({
  id: '/register-account',
  path: '/register-account',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateAccountRoute = ActivateAccountRouteImport.update({
  id: '/activate-account',
  path: '/activate-account',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRoute,
} as any)
const AuthenticatedStatisticsRoute = AuthenticatedStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPackagesRoute = AuthenticatedPackagesRouteImport.update({
  id: '/packages',
  path: '/packages',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOverviewRoute = AuthenticatedOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrganizationSettingsRoute =
  AuthenticatedOrganizationSettingsRouteImport.update({
    id: '/organization-settings',
    path: '/organization-settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFriskvardRoute = AuthenticatedFriskvardRouteImport.update({
  id: '/friskvard',
  path: '/friskvard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDepartmentsRoute =
  AuthenticatedDepartmentsRouteImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompetitionsIndexRoute =
  AuthenticatedCompetitionsIndexRouteImport.update({
    id: '/competitions/',
    path: '/competitions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUsersUserIdRoute =
  AuthenticatedUsersUserIdRouteImport.update({
    id: '/users/$userId',
    path: '/users/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompetitionsNewRoute =
  AuthenticatedCompetitionsNewRouteImport.update({
    id: '/competitions/new',
    path: '/competitions/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompetitionsCompetitionIdRoute =
  AuthenticatedCompetitionsCompetitionIdRouteImport.update({
    id: '/competitions/$competitionId',
    path: '/competitions/$competitionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticateddeveloperDesignSystemRoute =
  AuthenticateddeveloperDesignSystemRouteImport.update({
    id: '/(developer)/design-system',
    path: '/design-system',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticateddeveloperDebugRoute =
  AuthenticateddeveloperDebugRouteImport.update({
    id: '/(developer)/debug',
    path: '/debug',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activate-account': typeof ActivateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/register-account': typeof RegisterAccountRoute
  '/reset-password': typeof ResetPasswordRoute
  '/departments': typeof AuthenticatedDepartmentsRoute
  '/friskvard': typeof AuthenticatedFriskvardRoute
  '/organization-settings': typeof AuthenticatedOrganizationSettingsRoute
  '/overview': typeof AuthenticatedOverviewRoute
  '/packages': typeof AuthenticatedPackagesRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/statistics': typeof AuthenticatedStatisticsRoute
  '/login/': typeof LoginIndexRoute
  '/debug': typeof AuthenticateddeveloperDebugRoute
  '/design-system': typeof AuthenticateddeveloperDesignSystemRoute
  '/competitions/$competitionId': typeof AuthenticatedCompetitionsCompetitionIdRoute
  '/competitions/new': typeof AuthenticatedCompetitionsNewRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/competitions/': typeof AuthenticatedCompetitionsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activate-account': typeof ActivateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/onboarding': typeof OnboardingRoute
  '/register-account': typeof RegisterAccountRoute
  '/reset-password': typeof ResetPasswordRoute
  '/departments': typeof AuthenticatedDepartmentsRoute
  '/friskvard': typeof AuthenticatedFriskvardRoute
  '/organization-settings': typeof AuthenticatedOrganizationSettingsRoute
  '/overview': typeof AuthenticatedOverviewRoute
  '/packages': typeof AuthenticatedPackagesRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/statistics': typeof AuthenticatedStatisticsRoute
  '/login': typeof LoginIndexRoute
  '/debug': typeof AuthenticateddeveloperDebugRoute
  '/design-system': typeof AuthenticateddeveloperDesignSystemRoute
  '/competitions/$competitionId': typeof AuthenticatedCompetitionsCompetitionIdRoute
  '/competitions/new': typeof AuthenticatedCompetitionsNewRoute
  '/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/competitions': typeof AuthenticatedCompetitionsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/activate-account': typeof ActivateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/register-account': typeof RegisterAccountRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_authenticated/departments': typeof AuthenticatedDepartmentsRoute
  '/_authenticated/friskvard': typeof AuthenticatedFriskvardRoute
  '/_authenticated/organization-settings': typeof AuthenticatedOrganizationSettingsRoute
  '/_authenticated/overview': typeof AuthenticatedOverviewRoute
  '/_authenticated/packages': typeof AuthenticatedPackagesRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/statistics': typeof AuthenticatedStatisticsRoute
  '/login/': typeof LoginIndexRoute
  '/_authenticated/(developer)/debug': typeof AuthenticateddeveloperDebugRoute
  '/_authenticated/(developer)/design-system': typeof AuthenticateddeveloperDesignSystemRoute
  '/_authenticated/competitions/$competitionId': typeof AuthenticatedCompetitionsCompetitionIdRoute
  '/_authenticated/competitions/new': typeof AuthenticatedCompetitionsNewRoute
  '/_authenticated/users/$userId': typeof AuthenticatedUsersUserIdRoute
  '/_authenticated/competitions/': typeof AuthenticatedCompetitionsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate-account'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/register-account'
    | '/reset-password'
    | '/departments'
    | '/friskvard'
    | '/organization-settings'
    | '/overview'
    | '/packages'
    | '/settings'
    | '/statistics'
    | '/login/'
    | '/debug'
    | '/design-system'
    | '/competitions/$competitionId'
    | '/competitions/new'
    | '/users/$userId'
    | '/competitions/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate-account'
    | '/forgot-password'
    | '/onboarding'
    | '/register-account'
    | '/reset-password'
    | '/departments'
    | '/friskvard'
    | '/organization-settings'
    | '/overview'
    | '/packages'
    | '/settings'
    | '/statistics'
    | '/login'
    | '/debug'
    | '/design-system'
    | '/competitions/$competitionId'
    | '/competitions/new'
    | '/users/$userId'
    | '/competitions'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/activate-account'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/register-account'
    | '/reset-password'
    | '/_authenticated/departments'
    | '/_authenticated/friskvard'
    | '/_authenticated/organization-settings'
    | '/_authenticated/overview'
    | '/_authenticated/packages'
    | '/_authenticated/settings'
    | '/_authenticated/statistics'
    | '/login/'
    | '/_authenticated/(developer)/debug'
    | '/_authenticated/(developer)/design-system'
    | '/_authenticated/competitions/$competitionId'
    | '/_authenticated/competitions/new'
    | '/_authenticated/users/$userId'
    | '/_authenticated/competitions/'
    | '/_authenticated/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ActivateAccountRoute: typeof ActivateAccountRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  RegisterAccountRoute: typeof RegisterAccountRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register-account': {
      id: '/register-account'
      path: '/register-account'
      fullPath: '/register-account'
      preLoaderRoute: typeof RegisterAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate-account': {
      id: '/activate-account'
      path: '/activate-account'
      fullPath: '/activate-account'
      preLoaderRoute: typeof ActivateAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRoute
    }
    '/_authenticated/statistics': {
      id: '/_authenticated/statistics'
      path: '/statistics'
      fullPath: '/statistics'
      preLoaderRoute: typeof AuthenticatedStatisticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/packages': {
      id: '/_authenticated/packages'
      path: '/packages'
      fullPath: '/packages'
      preLoaderRoute: typeof AuthenticatedPackagesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/overview': {
      id: '/_authenticated/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof AuthenticatedOverviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organization-settings': {
      id: '/_authenticated/organization-settings'
      path: '/organization-settings'
      fullPath: '/organization-settings'
      preLoaderRoute: typeof AuthenticatedOrganizationSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/friskvard': {
      id: '/_authenticated/friskvard'
      path: '/friskvard'
      fullPath: '/friskvard'
      preLoaderRoute: typeof AuthenticatedFriskvardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/departments': {
      id: '/_authenticated/departments'
      path: '/departments'
      fullPath: '/departments'
      preLoaderRoute: typeof AuthenticatedDepartmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/competitions/': {
      id: '/_authenticated/competitions/'
      path: '/competitions'
      fullPath: '/competitions/'
      preLoaderRoute: typeof AuthenticatedCompetitionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/$userId': {
      id: '/_authenticated/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AuthenticatedUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/competitions/new': {
      id: '/_authenticated/competitions/new'
      path: '/competitions/new'
      fullPath: '/competitions/new'
      preLoaderRoute: typeof AuthenticatedCompetitionsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/competitions/$competitionId': {
      id: '/_authenticated/competitions/$competitionId'
      path: '/competitions/$competitionId'
      fullPath: '/competitions/$competitionId'
      preLoaderRoute: typeof AuthenticatedCompetitionsCompetitionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(developer)/design-system': {
      id: '/_authenticated/(developer)/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof AuthenticateddeveloperDesignSystemRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/(developer)/debug': {
      id: '/_authenticated/(developer)/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof AuthenticateddeveloperDebugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDepartmentsRoute: typeof AuthenticatedDepartmentsRoute
  AuthenticatedFriskvardRoute: typeof AuthenticatedFriskvardRoute
  AuthenticatedOrganizationSettingsRoute: typeof AuthenticatedOrganizationSettingsRoute
  AuthenticatedOverviewRoute: typeof AuthenticatedOverviewRoute
  AuthenticatedPackagesRoute: typeof AuthenticatedPackagesRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedStatisticsRoute: typeof AuthenticatedStatisticsRoute
  AuthenticateddeveloperDebugRoute: typeof AuthenticateddeveloperDebugRoute
  AuthenticateddeveloperDesignSystemRoute: typeof AuthenticateddeveloperDesignSystemRoute
  AuthenticatedCompetitionsCompetitionIdRoute: typeof AuthenticatedCompetitionsCompetitionIdRoute
  AuthenticatedCompetitionsNewRoute: typeof AuthenticatedCompetitionsNewRoute
  AuthenticatedUsersUserIdRoute: typeof AuthenticatedUsersUserIdRoute
  AuthenticatedCompetitionsIndexRoute: typeof AuthenticatedCompetitionsIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDepartmentsRoute: AuthenticatedDepartmentsRoute,
  AuthenticatedFriskvardRoute: AuthenticatedFriskvardRoute,
  AuthenticatedOrganizationSettingsRoute:
    AuthenticatedOrganizationSettingsRoute,
  AuthenticatedOverviewRoute: AuthenticatedOverviewRoute,
  AuthenticatedPackagesRoute: AuthenticatedPackagesRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedStatisticsRoute: AuthenticatedStatisticsRoute,
  AuthenticateddeveloperDebugRoute: AuthenticateddeveloperDebugRoute,
  AuthenticateddeveloperDesignSystemRoute:
    AuthenticateddeveloperDesignSystemRoute,
  AuthenticatedCompetitionsCompetitionIdRoute:
    AuthenticatedCompetitionsCompetitionIdRoute,
  AuthenticatedCompetitionsNewRoute: AuthenticatedCompetitionsNewRoute,
  AuthenticatedUsersUserIdRoute: AuthenticatedUsersUserIdRoute,
  AuthenticatedCompetitionsIndexRoute: AuthenticatedCompetitionsIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface LoginRouteChildren {
  LoginIndexRoute: typeof LoginIndexRoute
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginIndexRoute: LoginIndexRoute,
}

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ActivateAccountRoute: ActivateAccountRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  RegisterAccountRoute: RegisterAccountRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
